import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

import {
  BodyContent,
  InputLabelFileContent,
  TextContainer,
  TextLength,
  TitleContainer,
  TitleContent,
} from "./style";
import { t } from "i18next";
import { ChannelContext } from "../../../context/channel";
import Label from "../../shared/label/Label";
import PageTitle from "../../shared/pageTitle/PageTitle";
import PreviewImageModal from "../previewImageModal/PreviewImageModal";
import TextArea from "../../shared/textArea/TextArea";
import UploadImage from "../../shared/UploadImage";

const DescriptionBlock = () => {
  const dashboardContext = React.useContext(ChannelContext);

  const DESCRIPTION_MAX_LENGTH = 800;
  const TITLE_MAX_LENGTH = 200;

  const [titleText, setTitleText] = useState<string>(
    dashboardContext.descriptionTitle
  );
  const [descriptionText, setDescriptionText] = useState<string>(
    dashboardContext.descriptionText
  );
  const [uploadedFile, setUploadedFile] = useState<File | any>(
    dashboardContext.descriptionImageFile
  );
  const [fileImageUrl, setFileImageUrl] = useState<string>(
    dashboardContext.descriptionImageUrl
  );

  const isSmallScreen = useMediaQuery({ query: "(max-width: 950px)" });
  const isMediumScreen = useMediaQuery({ query: "(max-width: 1455px)" });
  const isLargerScreen = useMediaQuery({ query: "(min-width: 1800px)" });

  useEffect(() => {
    dashboardContext.setDescriptionImageFile(uploadedFile);
    dashboardContext.setDescriptionImageUrl(fileImageUrl);
  }, [fileImageUrl, uploadedFile]);

  const handleAutoGrow = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    e.target.style.height = `${e.target.scrollHeight}px`;
  };

  const handleTextChange = (
    e: React.ChangeEvent<HTMLTextAreaElement>,
    setText: React.Dispatch<React.SetStateAction<string>>
  ) => {
    setText(e.target.value);
    handleAutoGrow(e);
  };
  return (
    <BodyContent>
      <PageTitle>{t('dashboard.description.title')}</PageTitle>
      <TitleContainer>
        <InputLabelFileContent>
          <Label>Imagem</Label>
          <UploadImage
            uploadedFile={uploadedFile}
            maxImageWidth={520}
            maxImageHeight={390}
            fileImageUrl={fileImageUrl}
            setFileImageUrl={setFileImageUrl}
            setUploadedFile={setUploadedFile}
            inputId="input-file-description-block"
            idForUploadButton="input-upload-description-block"
            haveMarginLeft
            styleForInputLabelContainer={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
            styleForUploadedContainer={{
              marginLeft: "0",
              flexDirection: isSmallScreen ? "collumn" : "row",
            }}
            styleForFileRequirementContainer={{ width: "70%" }}
          />
        </InputLabelFileContent>
        <TitleContent>
          <Label>{t('title')}</Label>
          <TextContainer
            onBlur={() => dashboardContext.setDescriptionTitle(titleText)}
          >
            <TextArea
              onChange={(e) => handleTextChange(e, setTitleText)}
              value={titleText}
              maxLength={200}
              placeholder={t('dashboard.description.title.placeholder')!}
              style={{
                minHeight: isSmallScreen
                  ? "60px"
                  : isMediumScreen
                  ? "80px"
                  : "60px",
              }}
            />
            <TextLength>{`${titleText.length} / ${TITLE_MAX_LENGTH}`}</TextLength>
          </TextContainer>
        </TitleContent>
        <TitleContent>
          <Label>{t('text')}</Label>
          <TextContainer
            onBlur={() => dashboardContext.setDescriptionText(descriptionText)}
          >
            <TextArea
              onChange={(e) => handleTextChange(e, setDescriptionText)}
              value={descriptionText}
              maxLength={800}
              placeholder={t('dashboard.description.text.placeholder')!}
              style={{
                minHeight: isSmallScreen
                  ? "80px"
                  : isMediumScreen
                  ? "100px"
                  : isLargerScreen
                  ? "60px"
                  : "80px",
              }}
            />
            <TextLength>{`${descriptionText.length} / ${DESCRIPTION_MAX_LENGTH}`}</TextLength>
          </TextContainer>
        </TitleContent>
      </TitleContainer>
    </BodyContent>
  );
};

export default DescriptionBlock;
